import Actions from "../action";

const initialState = {
    isLoading: false,
    qraccessList: [],
    error: false,
}
const QrAccessListReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.QR_ACCESS_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.QR_ACCESS_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                qraccessList: action.data?.results || [],
                error: false
            };
        }
        case Actions.QR_ACCESS_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                qraccessList: [],
                error: action.error,
            };
        }
                default:
            return state;
    }
};

export default QrAccessListReducer;

export const getQrAccessListSelector = state => state?.QR_ACCESS?.qraccessList;
